import { render } from "./EditarPermisos.vue?vue&type=template&id=3eb4415a&scoped=true"
import script from "./EditarPermisos.vue?vue&type=script&lang=js"
export * from "./EditarPermisos.vue?vue&type=script&lang=js"

import "./EditarPermisos.vue?vue&type=style&index=0&id=3eb4415a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb4415a"]])

export default __exports__